import { useState } from 'react'
import { BsDot } from "react-icons/bs";
import PaymentModal from '../Modal/PaymentModal';
import { Skeleton } from '@mui/material';

const Paymentpage = () => {
  const [displayModal, setDisplayModal] = useState(true);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="grid gap-4  p-8  py-6  mt-[76px] sm:ml-[300px]">
        <div className=" items-center z-[1] ">
          <span className='font-[600] text-[26px]'>Payment</span>
        </div>
        {
          loading ?
            (
              <div className="menuitem rounded-[20px]  cursor-pointer w-full ">
                <div className="div h-[400px] rounded-[20px] flex items-center">

                  <Skeleton variant="rectangular" width="100%" className="rounded-[20px]" height="100%" />
                </div>
                <div className="p-2">
                  <Skeleton width="70%" height={50} />
                  <Skeleton width="60%" height={30} />
                </div>
              </div>
            ) :
            (
              <div className=" bg-white p-6  flex flex-col gap-5 rounded-[20px]">
                <div className="flex  items-start justify-between w-full ">
                  <span className='text-[18px] font-[600] text-[#131415] '>Congratulations! You're now ready to submit your video testimonial requests. 🎉</span>

                </div>
                <div className="bg-[#F6F6F6] p-4 rounded-[9px] grid gap-6 ">
                  <div className='flex flex-col  gap-2 text-[14px] items-start'>
                    <span className='text-[18px] font-[600]'>To continue : </span>
                    <div className="flex ">
                      <span ><BsDot size={20} /></span>
                      <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>Checkout: </span>Finalize your purchase to continue sending invitations and generate your personalized QR code.</p>
                    </div>
                  </div>
                  <div className='flex flex-col  gap-2 text-[14px] items-start'>
                    <span className='text-[18px] font-[600]'>Package summary : </span>
                    <div className="flex ">
                      <span ><BsDot size={20} /></span>
                      <p className='text-[#535861] '>You have added [Number of guests] to your event. You are therefore entitled to the [Name of package] package for the amount of [XX €].</p>
                    </div>
                  </div>
                  <div className='flex flex-col  gap-2 text-[14px] items-start'>
                    <span className='text-[18px] font-[600]'>Why upgrade to the full version? </span>
                    <div className="flex">
                      <span ><BsDot size={20} /></span>
                      <p className='text-[#535861] '><span className='font-[600] text-[#131415]'>Instant invitations:  </span>&nbsp;Your guests will receive your testimonial requests immediately.</p>
                    </div>
                    <div className="flex">
                      <span ><BsDot size={20} /></span>
                      <p className='text-[#535861] '><span className='font-[600] text-[#131415]'>Customized QR Code:   </span>&nbsp;Make it easy to participate with a QR code unique to your event.</p>
                    </div>
                    <div className="flex">
                      <span ><BsDot size={20} /></span>
                      <p className='text-[#535861]  '><span className='font-[600] text-[#131415]'>Full-featured access:  </span>&nbsp; Benefit from unlimited contact import, extended video storage and advanced personalization.</p>
                    </div>
                  </div>
                  <div className='flex flex-col  gap-2 text-[14px] items-start'>
                    <span className='font-[600] text-[#131415]'>Don't miss this opportunity!  </span>
                    <p className='text-[#535861] flex items-center '>Turn your events into memorable experiences with [Name of your platform]. Finalize your purchase now to unlock all these features.</p>
                  </div>
                </div>


              </div>
            )
        }
      </div>
      <PaymentModal
        displayModal={displayModal}
        setDisplayModal={setDisplayModal}
      />

    </>
  )
}

export default Paymentpage